import { AboutUsSection } from "@/components/about-us-section";
import { CallToActionSection } from "@/components/call-to-action-section";
import { useSEO } from "@/lib/use-seo";
import { breadcrumb } from "@/lib/seo-schemas";

const people = [
  {
    name: "Neil Morelli, PhD",
    jobTitle: "I/O Psychologist & Co-founder",
    sameAs: "https://www.linkedin.com/in/neilmorelli/",
    description:
      "I/O Psychologist whose research and practice focus on the intersection of technology and talent management — published one of the first empirical studies on mobile vs. non-mobile employment tests.",
  },
  {
    name: "Jonathan Flower",
    jobTitle: "AI Engineer & Co-founder",
    sameAs: "https://www.linkedin.com/in/jonathan-flower/",
    description:
      "AI engineer focused on building HR technology that is intuitive, useful, and grounded in how people actually work.",
  },
  {
    name: "Alexia Saphos",
    jobTitle: "HR Strategist",
    sameAs: "https://www.linkedin.com/in/alexia-saphos",
    description:
      "HR strategist designing frameworks that connect people strategy to business growth.",
  },
  {
    name: "Lindsay Hansen",
    jobTitle: "AI Ethics & People Systems Lead",
    sameAs: "https://www.linkedin.com/in/lthansen4",
    description:
      "Designs people systems at the intersection of AI, ethics, and workforce strategy.",
  },
].map((p) => ({
  "@context": "https://schema.org",
  "@type": "Person",
  worksFor: { "@type": "Organization", name: "AI for HR Mastermind" },
  ...p,
}));

export const AboutUs = () => {
  useSEO({
    title: "Meet Your Instructors",
    description:
      "Meet the researchers, builders, and practitioners behind the AI for HR Mastermind — an I/O Psychologist, AI engineer, and HR strategists who've spent their careers at the intersection of people and technology.",
    path: "/about-us",
    jsonLd: [
      breadcrumb([
        { name: "Home", path: "/" },
        { name: "About", path: "/about-us" },
      ]),
      ...people,
    ],
  });
  return (
    <div className="flex flex-col pt-32 md:pt-8">
      <AboutUsSection />
      <CallToActionSection />
    </div>
  );
};

export default AboutUs;
